import React, {useEffect} from 'react'
import '../../App.css';
import Cards from '../Cards';
import Footer from '../Footer';

const portfolioCards = [
    {
        src: 'images/img-car-26.jpg',
        text: "Automotive elegance: Design, power, and personality",
        label: 'CAR PORTRAITS',
        path: '/portfolio/cars',
    },
    {
        src: 'images/img-motorsport-14.jpg',
        text: 'Speed frozen in time: The thrill, the grit, the race',
        label: 'MOTORSPORTS',
        path: '/portfolio/motorsports',
    },
    {
        src: 'images/img-sports-4.jpg',
        text: 'Dynamic highlights: Strength, focus, and motion',
        label: 'SPORTS',
        path: '/portfolio/sports',
    },
    {
        src: 'images/img-portraits-1.jpg',
        text: 'Human connection: Authentic expressions and bold fashion statements',
        label: 'PORTRAITS',
        path: '/portfolio/portraits',
    },
    {
        src: 'images/img-events-3.jpg',
        text: 'Moments that matter: Celebrations and unforgettable memories',
        label: 'EVENTS',
        path: '/portfolio/events',
    },
    {
        src: 'images/img-travel-8.jpg',
        text: 'Finding beauty: Nature, landscapes, and architecture',
        label: 'TRAVEL',
        path: '/portfolio/travel',
    },
];

function Portfolio() {
    useEffect(() => {
        const timer = setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 50);
          
        return () => clearTimeout(timer);
    }, []);
    return (
        <>
            <h1 className='portfolio-hero'>Portfolio</h1>;
            <h1 className='text'>Explore a diverse gallery of photos</h1>
            <Cards cardsData={portfolioCards} />
            <Footer />
        </>
    )
}

export default Portfolio;
